module.exports = __webpack_public_path__ + "img/medal2.537242ae.svg";